export default function (stringValue) {
  return stringValue && stringValue !== '' ? stringValue : '-'
}
